import React from "react";

import { FooterBase } from "@app/components/footer/common/footer-base";
import { FooterBaseSection } from "@app/components/footer/footer-base-section";
import {
  useIsPoweredByWhitelabel,
  useWhitelabelContext
} from "@app/context/whitelabel-context";

import type { Partner } from "@partners/partner.type";

import { FunnelFooter as FunnelFooterBilletesBus } from "./billetesbus/billetesbus";
import { FunnelFooter as FunnelFooterDefault } from "./default/index";
import { FunnelFooter as FunnelFooterNeredenNereye } from "./neredennereye/neredennereye";
import { FunnelFooter as FunnelFooterRecorrido } from "./recorrido/recorrido";
import { FunnelFooter as FunnelFooterSkyscanner } from "./skyscanner/skyscanner";

const FUNNEL_FOOTER_WHITELABEL_MAPPING = {
  neredennereye: FunnelFooterNeredenNereye,
  busbud: FunnelFooterDefault,
  billetesbus: FunnelFooterBilletesBus,
  skyscanner: FunnelFooterSkyscanner,
  recorrido: FunnelFooterRecorrido
} as const satisfies Partial<Record<Partner | "busbud", React.FC>>;

type FunnelFooterWhitelabelMapping = typeof FUNNEL_FOOTER_WHITELABEL_MAPPING;
type FunnelFooterWhitelabelName = keyof FunnelFooterWhitelabelMapping;

const PoweredByWhitelabelFooter = () => {
  return (
    <FooterBaseSection>
      <FooterBase variant="default" />
    </FooterBaseSection>
  );
};

function getFunnelFooter(
  whitelabel_name: FunnelFooterWhitelabelName | (string & {}) | undefined
): React.FC {
  const Footer =
    FUNNEL_FOOTER_WHITELABEL_MAPPING[
      whitelabel_name as FunnelFooterWhitelabelName
    ];

  return Footer || FunnelFooterDefault;
}

export const FunnelFooter = React.memo(() => {
  const { whitelabel } = useWhitelabelContext();
  const whitelabel_name: string | undefined = whitelabel?.name;
  const is_powered_by = useIsPoweredByWhitelabel();

  if (!whitelabel_name) {
    return <FunnelFooterDefault />;
  }

  if (is_powered_by) {
    return <PoweredByWhitelabelFooter />;
  }

  const FunnelFooter = getFunnelFooter(whitelabel_name);
  return <FunnelFooter />;
});
